import React from "react"
import styled from "styled-components"

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 4rem !important;
  height: 2.5rem;
  outline: none;
  & span {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
  }
  & input {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
  }
`

const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.colors.red};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 2rem;

  &:before {
    position: absolute;
    content: "";
    height: 1.9rem;
    width: 1.9rem;
    left: 4px;
    bottom: 5px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const Input = styled.input`
  &:checked + ${Slider} {
    background-color: ${(props) => props.theme.colors.success};
  }

  &:focus + ${Slider} {
    box-shadow: 0 0 1px ${(props) => props.theme.colors.success};
  }

  &:checked + ${Slider} {
    &:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }
  }
`

export interface ToggleProps {
  onChange: (v: boolean) => void
  checked: boolean
  label: string
  name?: string
}
const Toggle: React.SFC<ToggleProps> = ({ onChange, checked, label, name }) => (
  <Switch>
    <span>{label}</span>
    <Input type="checkbox" checked={checked} onChange={() => onChange(!checked)} name={name} />
    <Slider />
  </Switch>
)

export default Toggle
